// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1h1Jx","alert":"SettungsInbox_alert__1QrhK"};